import split from 'lib/storeLocales/split';

const toPath =
  storeLocale =>
  ({ slug }) => ({
    params: { slug },
    locale: storeLocale,
  });

const createPaths = (storeLocales, localeSlugs) =>
  storeLocales.reduce((paths, storeLocale) => {
    const [, locale] = split(storeLocale);
    const slugs = localeSlugs[locale];
    const storeLocalePaths = slugs.map(toPath(storeLocale));
    return [...paths, ...storeLocalePaths];
  }, []);

export default createPaths;
